import React, { useRef, useState } from 'react';
import { Popover } from '@mui/material';
import styled from 'styled-components';
import { propsToClassKey } from '@mui/styles';
import IncrementTextButton from './IncrementTextButton';

interface IAdvancedFilterPopoverProps {
  filterCount: number;
  children?: React.ReactNode;
}

interface IPopoverState {
  id: string | null;
  open: boolean | null;
  anchor: HTMLButtonElement | null;
}

const PopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const PopoverChildrenContainer = styled.div`
  padding: 24px;
`;

const AdvancedFilterPopover: React.FC<IAdvancedFilterPopoverProps> = ({ children, filterCount }) => {
  const [state, setState] = useState<IPopoverState>({
    id: null,
    open: null,
    anchor: null,
  });

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setState({ anchor: e.currentTarget as HTMLButtonElement, open: true, id: e.currentTarget.id });
  };

  const handleClose = (e: React.FocusEvent<HTMLInputElement>) => {
    setState({ anchor: e.currentTarget as HTMLButtonElement, open: false, id: e.currentTarget.id });
  };

  return (
    <>
      <IncrementTextButton
        circleProps={{
          backgroundColor: 'white',
          color: 'red',
          size: 18,
          value: filterCount,
          fontSize: 10,
        }}
        buttonBackgroundColor={'red'}
        buttonTextColor={'white'}
        buttonText={'Advanced Filters'}
        onClick={handleOpen}
      />
      <PopoverContainer>
        <Popover
          id={state.id}
          open={state.open}
          anchorEl={state.anchor}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{ mt: '10px' }}
        >
          <PopoverChildrenContainer>
            {children}
          </PopoverChildrenContainer>
        </Popover>
      </PopoverContainer>
    </>
  );
};

export default AdvancedFilterPopover;
